






















































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { vuex } from "@/store";
import { watch } from 'vue';
import rest from "@/rest";
import draggable from 'vuedraggable';
// components
import ElementPalette from './ElementPalette.vue';
import MediaPool from './MediaPool.vue';
import CourseModules from './CourseModules.vue';
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
import CompSignature from '../ExerciseComponents/CompSignature.vue';
import TtsAudioElement from './TtsAudioElement.vue';
import ExpandableCard from '../Shared/ExpandableCard.vue';
import ImageElement from './ImageElement.vue';
import HeroHeadlineElement from './HeroHeadlineElement.vue';
import MarkdownElement from './MarkdownElement.vue';
import AiPodcastCreatorDlg from './AiPodcastCreatorDlg.vue';
import AiVideoCreatorDlg from './VideoCreationTool/AiVideoCreatorDlg.vue';
import SimpleMessageBox from '../Shared/SimpleMessageBox.vue';
import ModulePages from './ModulePages.vue';
import ElementSettings from './ElementSettings.vue';
import TextElement from './TextElement.vue';
import PdfElement from './PdfElement.vue';
import TtsReaderElement from './TtsReaderElement.vue';
import AudioElement from './AudioElement.vue';
import AudioPodcastElement from './AudioPodcastElement.vue';
import VideoElement from './VideoElement.vue';
import MultipleChoiceElement from './MultipleChoiceElement.vue';
import SingleChoiceElement from './SingleChoiceElement.vue';
import SignatureElement from './SignatureElement.vue';
import SliderElement from './SliderElement.vue';
import RatingElement from './RatingElement.vue';
import CommentElement from './CommentElement.vue';
import CustomTranslationDlg from './CustomTranslationDlg.vue';
import SequentialListElement from './SequentialListElement.vue';
import FlipCardListElement from './FlipCardListElement.vue';
import ScormElement from './ScormElement.vue';

// interfaces
import { drop, pull } from 'lodash';
import { ExerciseVM } from '@/interfaces/ExerciseVM';
import { CourseElementVm, CustomTranslationType } from '@/interfaces/CourseElementVm';
import { CcPageVm } from '@/interfaces/CcPageVm';
import { courseElementTypeItems } from '@/interfaces/Types';
import { CourseElementType } from '@/interfaces/CourseElementType';
import { ParamDictionary } from '@/interfaces/ParamDictionary';
import { ExType } from '@/interfaces/ExType';
import { FileDetailsVm } from '@/interfaces/FileDetailsVm';
import { AiModuleGeneratorVm } from '@/interfaces/AiModuleGeneratorVm';
import { CustomizationVm } from '@/interfaces/CustomizationVm';

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
    draggable,
    SimpleMessageBox,
    CourseModules,
    ElementPalette,
    MediaPool,
    TusFileDrop,
    TextElement,
    PdfElement,
    AudioElement,
    TtsAudioElement,
    TtsReaderElement,
    VideoElement,
    SingleChoiceElement,
    MultipleChoiceElement,
    SliderElement,
    RatingElement,
    CommentElement,
    CompSignature,
    ExpandableCard,
    ImageElement,
    HeroHeadlineElement,
    MarkdownElement,
    SequentialListElement,
    FlipCardListElement,
    SignatureElement,
    ScormElement,
    ModulePages,
    AudioPodcastElement,
    AiPodcastCreatorDlg,
    AiVideoCreatorDlg,
    CustomTranslationDlg,
    ElementSettings
  }
})
export default class CourseCreator extends Vue {
  @customization.Getter customizationSettings!: CustomizationVm;
  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter modulePages!: CcPageVm[];
  @globals.Getter selectedModulePage!: CcPageVm | null;
  @globals.Getter selectedModulePageIndex!: number;
  @globals.Getter selectedElement!: CourseElementVm | null;
  @globals.Getter isMasterLanguageCode!: boolean;
  @globals.Action selectExercise!: (exercise: ExerciseVM | null) => Promise<void>;
  @globals.Action loadModulePages!: () => Promise<void>;
  @globals.Action setModulePages!: (modulePages: CcPageVm[] | null) => Promise<void>;
  @globals.Action selectModulePage!: (number) => Promise<void>;
  @globals.Action saveModulePages!: (force: boolean) => Promise<void>;
  @globals.Action addAndSelectModulePage!: () => Promise<void>;
  @globals.Action deleteModulePage!: (number) => Promise<void>;
  @globals.Action setElement!: (element: CourseElementVm | null) => Promise<void>;
  @globals.Action refreshSelectedElement!: () => Promise<void>;
  @globals.Action refreshSelectedBundle!: () => Promise<void>;

  showConfirmDeletePage = false;
  showConfirmDeleteElement = false;
  showAiPodcastCreatorDlg = false;
  showAiVideoCreatorDlg = false;
  resolutionSelected = false;
  isBusy = false;
  // currentExercise: ExerciseVM | null = null;
  // selectedElement: CourseElementVm | null = null;
  translationCustomDlgElement: CourseElementVm | null = null;
  showCustomTranslationDlg = false;
  courseElementTypeItems = courseElementTypeItems;
  fileImportBusy = false;
  drag = false;
  selectedToolbarLeft: any = null;
  selectedToolbarRight = 0;

  $refs!: {};

  async mounted() {
    this.$root.$on('moduleUpdated:CourseCreator', this.moduleUpdated);
  }

  created() {
  }

  async beforeDestroy() {
    // console.log("beforeDestroy: CourseCreator");
    this.selectExercise(null);

    this.$root.$off('moduleUpdated:CourseCreator', this.moduleUpdated);
  }

  onEditElement(index: number) {
    const refName = `element-${index}`;
    // Note: Dynamic refs are arrays
    this.$refs[refName][0].openMarkdownEditor();
  }

  // onEditPodcast(index: number) {
  //   const refName = `podcast-${index}`;
  //   // Note: Dynamic refs are arrays
  //   this.$refs[refName][0].openPodcastEditor();
  // }

  async onAIPodcastCreatorClosed() {
    await this.$globalHelper.delay(20);
    // Refresh the selected element to get the updated AI summary
    await this.refreshSelectedElement();
  }

  async onAIVideoCreatorClosed() {
    await this.$globalHelper.delay(20);
    await this.refreshSelectedElement();
  }

  async onCreateResolution(): Promise<void> {
    if (!this.selectedExercise || !this.selectedModulePage) return;
    this.isBusy = true;

    // first save module pages to ensure we have the latest data
    await this.saveModulePages(false);

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
    params.dictionary!["PageId"] = this.selectedModulePage.id!.toString();

    await rest.url("contentManager/createResolutionForModulePage")
      .post(params)
      .then((response) => {
        if (response) {
          this.selectedModulePage!.resolutionElements = response as CourseElementVm[];
        }
      })
      .finally(async () => {
        this.isBusy = false;
        await this.refreshSelectedBundle();
      });
  }

  async moduleUpdated(data: AiModuleGeneratorVm) {
    console.log("CourseCreator: moduleUpdated", data);
    if (this.selectedExercise.id == data.exerciseId) {
      await this.loadModulePages();
    }

    vuex.ux.SB_SUCCESS({
      message: `Module '${data.name}' wurde aktualisiert.`,
      timeout: 3000
    });
  }

  // @Watch("selectedExercise")
  // async onSelectedExerciseChange() {
  //   if (!this.selectedExercise?.id)
  //     return;
  //   console.log("CourseCreator: onSelectedExerciseChange: " + this.selectedExercise.id);

  //   // save current pages before load pages for new module
  //   // if (this.currentExercise)
  //   //   await this.saveModulePages(false);

  //   // await this.loadModulePages();

  //   this.currentExercise = this.selectedExercise;
  // }

  @Watch("selectedModulePage")
  async onSelectedModulePageChanged() {
    this.resolutionSelected = false;
    await this.setElement(null);
  }

  get currentElements() {
    return this.resolutionSelected
      ? this.selectedModulePage?.resolutionElements
      : this.selectedModulePage?.courseElements;
  }

  set  currentElements(newValue) {
    if (!this.selectedModulePage) return;

    if (this.resolutionSelected) {
      this.selectedModulePage.resolutionElements = newValue!;
    } else {
      this.selectedModulePage.courseElements = newValue!;
    }
  }

  firstQuestion(): void {
    this.selectModulePage(0);
  }

  lastQuestion(): void {
    this.selectModulePage(this.modulePages.length - 1);
  }

  prevQuestion(): void {
    if (!this.selectedModulePage) return;

    this.selectModulePage(this.modulePages.indexOf(this.selectedModulePage) - 1);
  }

  nextQuestion(): void {
    if (!this.selectedModulePage) return;
    // const index = this.modulePages.indexOf(this.selectedQuestion);
    // if (index < this.modulePages.length - 1) {
    //   this.selectedQuestion = this.modulePages[index + 1];
    // }
    this.selectModulePage(this.modulePages.indexOf(this.selectedModulePage) + 1);
  }

  // get questionIndex(): number {
  //   if (!this.modulePages || this.modulePages.length == 0 || !this.selectedModulePage) return 0;

  //   return this.modulePages.indexOf(this.selectedModulePage) + 1;
  // }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }

  async onScromElementUpdated() {
    await this.saveModulePages(false);
    this.$root.$emit('updateModules:CourseModules');
  }

  get enableResolution(): boolean {
    if (!this.selectedExercise) return false;
    // If selected page contains single or multiple choice questions, return true
    if (this.selectedModulePage?.courseElements?.some(el => el.type === "SingleChoice" || el.type === "MultipleChoice")) {
      return true;
    }
    return false;
  }

  get disableAddPage() {
    if (this.selectedExercise?.type == ExType[ExType.Signature] && this.modulePages.length >= 0)
      return true;
    if (this.selectedExercise?.type == ExType[ExType.Scorm] && this.modulePages.length >= 0)
      return true;
    if (this.selectedExercise.type == 'Test' && this.selectedExercise.autoGenerateTest)
      return true;

    return false;
  }

  onElementsChange(event: any) {
    console.log("onElementsChange");
    // if (event.added) {
    //   console.log('Element hinzugefügt:', event.added.element);
    //   console.log('Zur Liste:', event.to);
    // }
    // if (event.removed) {
    //   console.log('Element entfernt:', event.removed.element);
    //   console.log('Aus Liste:', event.from);
    // }
    this.indexElements();
  }

  indexElements() {
    if (!this.selectedModulePage) return;

    if (this.selectedModulePage.courseElements) {
      this.selectedModulePage.courseElements.forEach((element, index) => {
        element.id = index + 1;
      });
    }

    if (this.selectedModulePage.resolutionElements) {
      this.selectedModulePage.resolutionElements.forEach((element, index) => {
        element.id = index + 1;
      });
    }
  }

  // Optional: Method to insert elements at a specific position
  // public addElement(element: CourseElementVm, index?: number): void {
  //   console.log("addElement", element, index);
  //   console.log("addElement index:", index);
  //   if (index !== undefined && index >= 0 && index <= this.courseElements.length) {
  //     this.courseElements.splice(index, 0, element);
  //   } else {
  //     this.courseElements.push(element);
  //   }
  //   this.indexElements();
  // }

  onDragEnd() {
    // Reset drag flag AFTER the click event that fires post-mouseup has been processed,
    // so onElementCLicked can ignore it.
    this.$nextTick(() => { this.drag = false; });
  }

  async onElementCLicked(element: CourseElementVm) {
    if (this.drag) return; // ignore click fired right after a drag
    await this.setElement(element);
  }

  async onConfirmDeleteElement(element: CourseElementVm) {
    await this.setElement(element);
    this.showConfirmDeleteElement = true;
  }

  async deleteElement(): Promise<void> {
    if (!this.selectedModulePage || !this.selectedElement) return;

    // call cleanUpCourseElementResources in contentManager controller to clean up resources (e.g. media files) associated with the element
    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["ExerciseId"] = this.selectedExercise!.id!.toString();
    params.dictionary!["ElementGuid"] = this.selectedElement!.guid!.toString();
    rest.url("contentManager/cleanUpCourseElementResources").post(params); // do not await, as we do not want to block the UI

    if (this.resolutionSelected)
      this.selectedModulePage.resolutionElements = this.selectedModulePage.resolutionElements!.filter(e => e.id !== this.selectedElement!.id);
    else
      this.selectedModulePage.courseElements = this.selectedModulePage.courseElements!.filter(e => e.id !== this.selectedElement!.id);

    // If selected module page do not contain any sigle of multiple choice questions, clear resolution elements
    if (!this.selectedModulePage.courseElements?.some(el => el.type === "SingleChoice" || el.type === "MultipleChoice")) {
      this.selectedModulePage.resolutionElements = [];
    }

    this.indexElements();
    await this.setElement(null);

    // let params: ParamDictionary = { dictionary: {}};
    // params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
    // params.dictionary!["FilePath"] = this.selectedElement!.contentUrl!;
    // if ((element.type === "Image" || element.type === "Video" || element.type === "Audio" || element.type === "TtsAudio") && element.contentUrl) {
    //   await rest.url("contentManager/removeMediaFromBundle").post(params);
    // }
  }

  onConfirmDeletePages() {
    this.showConfirmDeletePage = true;
  }

  async onDeletePage(): Promise<void> {
    if (!this.selectedModulePage) return;
    const index = this.modulePages.indexOf(this.selectedModulePage);
    await this.deleteModulePage(index);
  }

  showCustomTranslation(element: CourseElementVm) {
    this.translationCustomDlgElement = element;
    this.showCustomTranslationDlg = true;
  }

  getExerciseStyle(element: CourseElementVm) {
    const colorAccentHex = this.$store.state.ux.colorAccent;
    const colorWarningHex = this.$store.state.ux.colorWarning;
    let style = "";
    if (element == this.selectedElement)
      style = `border: 2px solid ${this.$store.state.ux.colorAccent};`;

    if (element.invisible) {
      const rgba = this.hexToRgba("#808080", 0.15);
      style += `background-color: ${rgba};`;
    } else if (this.getCustomTranslationStatus(element) == CustomTranslationType.Custom) {
      const rgba = this.hexToRgba(colorAccentHex, 0.15);
      style += `background-color: ${rgba};`;
    } else if (this.getCustomTranslationStatus(element) == CustomTranslationType.Conflict
      // || (element.type == "MultipleChoice" && (!element.text || element.options?.some(o => !o.text)))
      // || (element.type == "SingleChoice" && (!element.text || element.options?.some(o => !o.text)))
    ) {
      const rgba = this.hexToRgba(colorWarningHex, 0.20);
      style += `background-color: ${rgba};`;
    }

    return style;
  }

  isTranslationCustom(element: CourseElementVm): boolean {
    return this.getCustomTranslationStatus(element) == CustomTranslationType.Custom;
  }

  isTranslationConflict(element: CourseElementVm): boolean {
    return this.getCustomTranslationStatus(element) == CustomTranslationType.Conflict;
  }

  getCustomTranslationStatus(element: CourseElementVm): CustomTranslationType {
    if (!element) return CustomTranslationType.Master;

    if (element.textCustomTranslation == CustomTranslationType.Conflict
        || element.contentUrlCustomTranslation == CustomTranslationType.Conflict
        // || element.aiSummaryCustomTranslation == CustomTranslationType.Conflict
        || element.altTextCustomTranslation == CustomTranslationType.Conflict
        || element.titleCustomTranslation == CustomTranslationType.Conflict
        || element.leftLabelCustomTranslation == CustomTranslationType.Conflict
        || element.rightLabelCustomTranslation == CustomTranslationType.Conflict
        || element.options?.some(o => o.customTranslation == CustomTranslationType.Conflict)
    ) {
      return CustomTranslationType.Conflict;
    }

    if (element.textCustomTranslation == CustomTranslationType.Custom
        || element.contentUrlCustomTranslation == CustomTranslationType.Custom
        // || element.aiSummaryCustomTranslation == CustomTranslationType.Custom
        || element.altTextCustomTranslation == CustomTranslationType.Custom
        || element.titleCustomTranslation == CustomTranslationType.Custom
        || element.leftLabelCustomTranslation == CustomTranslationType.Custom
        || element.rightLabelCustomTranslation == CustomTranslationType.Custom
        || element.options?.some(o => o.customTranslation == CustomTranslationType.Custom)
    ) {
      return CustomTranslationType.Custom;
    }

    return CustomTranslationType.Master;
  }

  private hexToRgba(hex: string, alpha: number) {
    if (!hex) return `rgba(25,118,210,${alpha})`;
    let h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map(c => c + c).join('');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  // AI audio podcast
  async onCreateAudioPodcast(element: CourseElementVm): Promise<void> {
    if (!element.file) {
      element.file = `[Podcast] ${element.guid}.json`;
    }

    await this.saveModulePages(false);
    // this.selectedElement = element;
    await this.$globalHelper.delay(10); // ensure selectedElement is set in store before opening dialog
    this.showAiPodcastCreatorDlg = true;
  }

  // AI video
  async onCreateVideo(element: CourseElementVm): Promise<void> {
    if (!element.file) {
      element.file = `[Video] ${element.guid}.json`;
    }

    await this.saveModulePages(false);
    // this.selectedElement = element;
    await this.$globalHelper.delay(10); // ensure selectedElement is set in store before opening dialog
    this.showAiVideoCreatorDlg = true;
  }
}
